export const environment = {
    production: false,
    geminiApiKey:"AIzaSyB3X3ldS0GfD1eWtDMo28t84_z-4vQMmvE",
    firebaseConfig: {
        apiKey: "AIzaSyAFdSPlsxPmxANe5J4HpCyFDTO5pg60kqw",
        authDomain: "ravprep-69a5a.firebaseapp.com",
        projectId: "ravprep-69a5a",
        storageBucket: "ravprep-69a5a.firebasestorage.app",
        messagingSenderId: "631406616098",
        appId: "1:631406616098:web:12c6200fd06ee3a179747b",
        measurementId: "G-BBJB4VYH87",
    }
};